import React, {Fragment} from 'react';
import ReportTT from './report-tt';
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import iconTTstart from '../../../../assets/img/icon-tt-start.svg';

const ThinkingTalentsHome = () => {

    const user = useSelector(state => state.user );
    const questions_list = useSelector(state => state.questions)

    return (
        <div className="p-3">

            {(!user.talents || user.talents.length) === 0 &&
                (<>
                    <div className='text-center py-5'>
                        <img src={iconTTstart} width="78" height="78" alt='Thinking Talent'/>
                        <p className="my-4 mt-md-2">Start your <strong>Thinking Talent</strong> assessment to see it come to life!</p>
                        <Link to='/thinking-talents' className="btn btn-sm btn-outline-green-light">
                            <i className="mr-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                                    <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                                </svg>
                            </i>Let’s start!
                        </Link>
                    </div>
                </>)}

            {user.talents && user.talents.length > 1 &&
                <>  
                    <ReportTT showAllItems={true} />
                    <p className='text-center text-muted mb-4'><em>Tap the quadrants to view more information</em></p>
                    <div className='quadrants-reference'>
                        {questions_list.quadrants.map((item, index)=>(
                            <Fragment key={index}>
                            {item.name.toLowerCase() !== 'all' ? (
                                <div>
                                    <h4 className='h5'><i className={`mr-2 align-text-top icon`}>
                                        <svg width="10" height="10"><circle cx="5" cy="5" r="5" fill={item.color}/></svg>
                                    </i>{item.name}</h4>
                                    <p className='text-muted'>{item.excerpt}</p>
                                </div>
                            ) : (
                                <div>
                                    <h4 className='h5 mr-2 d-inline'><i className={`mr-2 align-text-top icon`}>
                                        <svg width="10" height="10"><circle cx="5" cy="5" r="5" fill={item.color}/></svg>
                                    </i>{item.name}</h4>
                                    <p className='text-muted d-inline'>{item.excerpt}</p>
                                </div>
                            )}
                            </Fragment>
                        ))}
                    </div>
                </>
            }

        </div>
)
}
const mapStateToProps = (state, props) => {
    const { user } = state;
    return { user };
};

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ThinkingTalentsHome);
